// extracted by mini-css-extract-plugin
module.exports = {"page":"chapter-page_page__2fe5y","select":"chapter-page_select__q_HXJ","keyword":"chapter-page_keyword__o8Nbb"};